import { render } from "./vsharedvcback.vue?vue&type=template&id=3fc82478&scoped=true"
import script from "./vsharedvcback.vue?vue&type=script&lang=js"
export * from "./vsharedvcback.vue?vue&type=script&lang=js"

import "./vsharedvcback.vue?vue&type=style&index=0&id=3fc82478&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc82478"]])

export default __exports__